import ExodusModule from '@exodus/module';
import { DEFAULT_PREFILL_OPTIONS } from './constants';
import getBalance from '../utils/get-balance';
const MODULE_ID = 'exchangeLimits';
export class ExchangeLimits extends ExodusModule {
    #exchangeAssets;
    #balancesAtom;
    #exchangeProviders;
    #exchangeRemoteConfigAtom;
    #logger;
    constructor(params) {
        super({ MODULE_ID, logger: params.logger });
        this.#balancesAtom = params.balancesAtom;
        this.#exchangeAssets = params.exchangeAssets;
        this.#exchangeProviders = params.exchangeProviders;
        this.#exchangeRemoteConfigAtom = params.exchangeRemoteConfigAtom;
        this.#logger = params.logger;
    }
    getLimits = async ({ pairId }) => {
        return this.#exchangeProviders.getExchangeLimits({
            pairId,
            opts: await this.#exchangeRemoteConfigAtom.get(),
        });
    };
    getPrefilledAmounts = async ({ fromWalletAccount, pairId }) => {
        try {
            const [fromAssetId] = pairId.split('_');
            const [balances, limits] = await Promise.all([
                this.#balancesAtom.get(),
                this.#exchangeProviders.getExchangeLimits({
                    pairId,
                    opts: await this.#exchangeRemoteConfigAtom.get(),
                }),
            ]);
            const asset = this.#exchangeAssets.getAsset({ assetId: fromAssetId });
            const balance = getBalance({
                assetName: asset.name,
                balances,
                walletAccount: fromWalletAccount,
            });
            const isBalanceUsable = balance.unitType.equals(limits.ExactIn.max.unitType) &&
                balance.lte(limits.ExactIn.max) &&
                balance.gte(limits.ExactIn.min);
            if (isBalanceUsable) {
                return [
                    { label: 'Min', value: limits.ExactIn.min },
                    { label: 'Half', value: balance.div(2) },
                    { label: 'All', value: balance },
                ];
            }
            return [
                { label: 'Min', value: limits.ExactIn.min },
                { label: 'Half', value: limits.ExactIn.max.div(2) },
                { label: 'Max', value: limits.ExactIn.max },
            ];
        }
        catch (err) {
            this.#logger.error(err);
            return DEFAULT_PREFILL_OPTIONS;
        }
    };
}
const exchangeLimitsModuleFactory = (args) => new ExchangeLimits({ ...args });
const exchangeLimitsModuleDefinition = {
    id: MODULE_ID,
    type: 'module',
    factory: exchangeLimitsModuleFactory,
    dependencies: [
        'balancesAtom',
        'exchangeAssets',
        'exchangeProviders',
        'exchangeRemoteConfigAtom',
        'logger',
    ],
};
export default exchangeLimitsModuleDefinition;
